

var apikey;
console.log(process.env)
if (process.env.NODE_ENV === "development") {
  apikey = 'pk_test_n8CLRZoY72ELI4jY7TAmFBLR00tLzmqLho';
} else {
  apikey = "pk_live_mbHG6SohchZY5AbMyJ69mq3v00k1rBmhKa"
}
export { apikey }